import { render, staticRenderFns } from "./ShowInvoice.vue?vue&type=template&id=4bb4885e&scoped=true&"
import script from "./ShowInvoice.vue?vue&type=script&lang=js&"
export * from "./ShowInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ShowInvoice.vue?vue&type=style&index=0&id=4bb4885e&lang=scss&scoped=true&"
import style1 from "./ShowInvoice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4885e",
  null
  
)

export default component.exports